module.exports = "https://www.gc-qa.gnp.com.mx/7e138d5f3bac65685a2c85012bac1eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/previous.png
// module id = 8160
// module chunks = 0